import { render, staticRenderFns } from "./BaseReadOnlyTextField.vue?vue&type=template&id=3464cb37"
import script from "./BaseReadOnlyTextField.vue?vue&type=script&lang=js"
export * from "./BaseReadOnlyTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports